import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import AlertModal from "../components/shared/AlertModal";
import "../scss/pages/Register.scss";
import axios from "axios";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import AdminUserRegistrationForm from "../components/shared/AdminUserRegistrationForm";
import { useOktaAuth } from "@okta/okta-react";
import AdminList from "../components/shared/AdminList";
import { selectUser } from "../features/user/userSlice";
import { useSelector } from "react-redux";

const EssilorAdmin = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { authState } = useOktaAuth();
  const history = useHistory();
  const [adminList, setAdminLIst] = useState([]);
  const user = useSelector(selectUser);

  useEffect(() => {
    if (user?.userRole !== 'ESSILORADMIN') {
      history.push('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[user])
  useEffect(() => {
    if (authState?.accessToken) {
      axios
        .get(process.env.REACT_APP_API_ENDPOINT + "essiloradmin/user", {
          headers: { Authorization: `Bearer ${authState.accessToken.accessToken}` }
        })
        .then((res) => {
          setAdminLIst(res.data);
        });
    }
  }, [authState]);

  const formSchema = Yup.object().shape({
    FirstName: Yup.string().required(),
    LastName: Yup.string().required(),
    UserRole: Yup.string().required(),
    Email: Yup.string().required().email(),
    PracticeName: Yup.string().required(),
    AreaOfExpertise: Yup.string().required(),
    Enabled: Yup.boolean(),
    Password: Yup.string()
      .required("Password is mandatory")
      .min(3, "Password must be at 3 char long")
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase and One Number"
      )
      .test(
        "Should not contain a user ID",
        "Should not contain a user ID",
        (value, ctx) => {
          const username = ctx.parent.Email.split("@")[0];
          return value.indexOf(username) === -1;
        }
      ),
  });

  const formOptions = { resolver: yupResolver(formSchema) };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
  } = useForm(formOptions);

  const handleSubmitRegistration = (payload) => {
    setIsLoading(true);
    const user = {
      firstName: payload.FirstName,
      lastName: payload.LastName,
      userRole: payload.UserRole,
      email: payload.Email,
      practiceName: payload.PracticeName,
      areaOfExpertise: payload.AreaOfExpertise,
      password: payload.Password,
      enabled: true,
    };
    axios
      .post(process.env.REACT_APP_API_ENDPOINT + "essiloradmin/user", user)
      .then(
        (response) => {
          setShowSuccess(true);
          reset();
          setIsLoading(false);
        },
        (err) => {
          setShowError(true);
          setIsLoading(false);
        }
      );
  };

  const handleCloseSuccess = () => {
    setShowSuccess(false);
  };

  const handleLogin = () => {
    handleCloseSuccess();
    history.push("/login");
  };

  const handleSuccessOrFail = () => {
    setSuccess(!success);
  };

  const handleCloseError = () => {
    setShowError(false);
  };

  const handleSubmitError = (err) => {
    console.log(err, "err");
  };

  return (
    <>
      <AdminList
        data={adminList}
      ></AdminList>
      <AdminUserRegistrationForm
        handleSubmit={handleSubmit}
        control={control}
        errors={errors}
        register={register}
        handleSubmitRegistration={handleSubmitRegistration}
        handleSubmitError={handleSubmitError}
        isLoading={isLoading}
        handleSuccessOrFail={handleSuccessOrFail}
      ></AdminUserRegistrationForm>
      <AlertModal
        show={showSuccess}
        handleClose={handleCloseSuccess}
        modalTitle={"Registration Successful"}
        modalBody={
          "You have successfully registered. Please click the link below to login."
        }
        handleConfirmButton={handleLogin}
        confirmButton={"Login"}
      ></AlertModal>
      <AlertModal
        show={showError}
        handleClose={handleCloseError}
        modalTitle={"Registration Unsuccessful"}
        modalBody={
          "There is a problem with your registration. Please try again later."
        }
        handleConfirmButton={handleCloseError}
        confirmButton={"Close"}
      ></AlertModal>
    </>
  );
};

export default EssilorAdmin;
